<script>
  import u from './utilities';
  export let entries = [];
  export let name = '';
  export let number = '';
</script>

<div class="log-entries">
  <h2>{#if number == null}Alle Einträge{:else}Einträge für {name}{/if}</h2>
  <ul>
    {#each entries as e}
    <li class="entry"><span class='date'>{u.renderDate(e.UsedOn)}</span><span class='type'>{e.TypeDisplayName}</span> <span class='name'>{e.AddedBy}</span>
    {#if e.RemarksByCustomer}<span class="remarks">{@html e.RemarksByCustomer}</span>
    {/if}
    </li>
    {/each}
  </ul>
</div>